import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Config } from '../.env.js';

const ParticipantsPage = () => {
    const [participants, setParticipants] = useState([]);
    const [filteredParticipants, setFilteredParticipants] = useState([]);

    const [search, setSearch] = useState('');
    const [campaignFilter, setCampaignFilter] = useState('');
    const [dateFilter, setDateFilter] = useState('');

    useEffect(() => {
        axios.get(`${Config.API_URL}/api/participants`)
            .then(res => {
                setParticipants(res.data);
                setFilteredParticipants(res.data);
            })
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        let filtered = [...participants];

        // Apply participant name/email search
        if (search) {
            filtered = filtered.filter(p =>
                p.name.toLowerCase().includes(search.toLowerCase()) ||
                p.email.toLowerCase().includes(search.toLowerCase())
            );
        }

        // Filter by campaign name
        if (campaignFilter) {
            filtered = filtered.filter(p =>
                p.appliedCampaigns.some(c =>
                    c.campaignName.toLowerCase().includes(campaignFilter.toLowerCase())
                )
            );
        }

        // Filter by date (format: yyyy-mm-dd)
        if (dateFilter) {
            filtered = filtered.filter(p =>
                p.appliedCampaigns.some(c =>
                    c.createdAt?.slice(0, 10) === dateFilter
                )
            );
        }

        setFilteredParticipants(filtered);
    }, [search, campaignFilter, dateFilter, participants]);

    return (
        <div className="container">
            <h2>All Participants and Their Applied Campaigns</h2>

            {/* Filters */}
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                <input
                    type="text"
                    placeholder="Search by name or email"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Filter by campaign name"
                    value={campaignFilter}
                    onChange={e => setCampaignFilter(e.target.value)}
                />
                <input
                    type="date"
                    value={dateFilter}
                    onChange={e => setDateFilter(e.target.value)}
                />
            </div>

            {/* Display filtered participants */}
            {filteredParticipants.map(participant => (
                <div key={participant.userId} className="box">
                    <strong>{participant.name} ({participant.email})</strong>
                    <ul>
                        {participant.appliedCampaigns.length ? (
                            participant.appliedCampaigns.map(campaign => (
                                <li key={campaign.campaignId}>
                                    {campaign.campaignName} - {campaign.brandName} ({new Date(campaign.createdAt).toLocaleDateString()})
                                </li>
                            ))
                        ) : (
                            <li>No campaigns applied</li>
                        )}
                    </ul>
                </div>
            ))}
        </div>
    );
};

export default ParticipantsPage;
